import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Router from "./router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BooleanProvider } from "./components/PosScreen/globalState/ItemFlag";

const queryClient = new QueryClient();
function App() {
  return (
    <div className="bg-gray-100 h-[100vh] overflow-hidden">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <BooleanProvider>
            <Router />
          </BooleanProvider>
        </BrowserRouter>
        <ToastContainer autoClose={1200} />
      </QueryClientProvider>
    </div>
  );
}

export default App;
